import Gtm from '@grebban/gtm';

export default ({ search_term }: {
    search_term: string;
}) => {
    Gtm.addDataLayerEvent('search', {
        search_term: search_term
    });
}